import { useTranslation } from "react-i18next";
import { formatAboPV } from "../../../../Lit/acc-mixins/l10n.js";
import { storedLocale, marketCode } from "../../../../Authentication/util";
import defaultContent from "../../../../../content/groupManagement";
import type { CustomerOrderItem } from "../CustomerOrdersWrapper/CustomerOrdersWrapper.types";
import { useOrderNavigation } from "../CustomerOrdersWrapper/CustomerOrdersWrapper.utils";
import { formatDateKpi } from "../../../../../common/util/formatDate";
import TEALIUM from "../../../../../common/enums/tealium-enums";
import { track } from "../../../../../common/util/tealium";
import "./CustomerOrdersCardMobile.scss";

export const CustomerOrdersCardMobile = ({ orders }: { orders: CustomerOrderItem[] }) => {
  const { t } = useTranslation(["groupManagement"]);
  const { handleOrderClick } = useOrderNavigation();
  const locale = storedLocale();
  const market = marketCode();

  return (
    <ul className="customer-orders-card-mobile__order-list">
      {orders.map((item, index) => {
        const formattedDate = formatDateKpi(item.orderDate, locale);
        const formattedPv = formatAboPV(item.customerPv, locale, market);
        const pvLabel = t("customerPv", defaultContent["customerPv"], { value: formattedPv });
        const orderedLabel = t("ordered", defaultContent["ordered"], { date: formattedDate });
        const ariaLabel = `View order for ${item.customerName}, ${formattedDate}, ${pvLabel}`;

        return (
          <li key={index} className="customer-orders-card-mobile__order-item">
            <button
              type="button"
              className="customer-orders-card-mobile__order-card"
              onClick={() => {
                handleOrderClick(item.affAbo);
                track(
                  TEALIUM.U_TAG_METHOD.LINK,
                  TEALIUM.EVENT_NAME.CLICK_ACTION,
                  TEALIUM.CATEGORY.GROUP_MANAGEMENT,
                  "customer_orders",
                  "",
                  "order_click",
                );
              }}
              aria-label={ariaLabel}
            >
              <span className="customer-orders-card-mobile__customer-name">{item.customerName}</span>
              <div className="customer-orders-card-mobile__order-footer">
                <span className="customer-orders-card-mobile__order-date">{orderedLabel}</span>
                <span className="customer-orders-card-mobile__order-pv">{pvLabel}</span>
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
};
